<template>
  <v-btn
    color="#FFFFFF"
    @click="clickAction"
    block
    class="font-weight-bold normal-button"
    elevation="0"
    height="44px"
    v-if="formShow"
  >
    <p>{{buttonTitle}}</p>
  </v-btn>
</template>

<script>

export default {
  name: "NormalButton",
  data: () => ({
  }),
  methods: {
    clickAction(){
      this.$emit('clickAction');
    }
  },
  components: {
  },
  props: ['buttonTitle', 'formShow']
};

</script>

<style scoped>
p {
  color: #3b4043;
  margin: 0;
}
.normal-button {
  border-radius: 12px;
}
</style>
